import React, { useState, useEffect } from 'react';
import { api } from './App';
import './ImportHistory.css';

const PAGE_SIZE = 20;

function formatDate(isoStr) {
  if (!isoStr) return '—';
  const d = new Date(isoStr);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

// Defined outside ImportHistory to avoid DOM remount on every render
function ImportHistoryHeader() {
  return (
    <header className="imh-header">
      <div className="imh-header-inner">
        <a href="/app" className="imh-brand">
          <svg viewBox="0 0 64 64" width="28" height="28" aria-hidden="true">
            <polygon points="6,54 24,54 34,30 16,30" fill="#ffffff" opacity="0.3"/>
            <polygon points="20,46 38,46 48,22 30,22" fill="#ffffff" opacity="0.6"/>
            <polygon points="34,38 52,38 62,14 44,14" fill="#ffffff" opacity="0.95"/>
          </svg>
          <span className="imh-wordmark"><span className="imh-wm-sqe">SQE</span><span className="imh-wm-track">Track</span></span>
        </a>
      </div>
    </header>
  );
}

export default function ImportHistory() {
  const hasToken = !!localStorage.getItem('sqetrack_token');
  const [imports,  setImports]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const [shown,    setShown]    = useState(PAGE_SIZE);

  useEffect(() => {
    if (!hasToken) { setError('not-logged-in'); setLoading(false); return; }
    api('/api/import/history')
      .then(data => {
        if (data.error) throw new Error(data.error);
        setImports(data.imports || []);
      })
      .catch(e => setError(e.message || 'network'))
      .finally(() => setLoading(false));
  }, [hasToken]);

  function goToImport(id) {
    window.location.href = `/import-summary?id=${id}`;
  }

  if (!hasToken) return (
    <div className="imh-page">
      <ImportHistoryHeader />
      <div className="imh-content">
        <div className="imh-empty">
          <div className="imh-empty-title">Log in to view import history</div>
          <div className="imh-empty-body"><a href="/login" style={{color:'#3B82F6'}}>Log in to SQETrack</a></div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="imh-page">
      <ImportHistoryHeader />
      <div className="imh-content">
        <a className="imh-back" href="/app">← Back to dashboard</a>
        <h1 className="imh-heading">Import history</h1>

        <div className="imh-card">
          {loading ? (
            <table className="imh-table">
              <thead><tr><th>Date</th><th>Source</th><th>Paper</th><th>Topics matched</th><th>Questions</th></tr></thead>
              <tbody>
                {[1,2,3].map(i => (
                  <tr key={i}>
                    {[70,60,40,40,40].map((w, j) => (
                      <td key={j}><div className="imh-shimmer" style={{width:`${w}%`}} /></td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : error ? (
            <div className="imh-empty">
              <div className="imh-empty-title">Couldn't load import history</div>
              <div className="imh-empty-body">{error === 'not-logged-in' ? 'Please log in.' : 'Check your connection and refresh.'}</div>
            </div>
          ) : imports.length === 0 ? (
            <div className="imh-empty">
              <div className="imh-empty-title">No imports yet</div>
              <div className="imh-empty-body">When you import scores from Law Drills, they'll appear here.</div>
            </div>
          ) : (
            <>
              <table className="imh-table">
                <thead>
                  <tr>
                    <th className="imh-td-date">Date</th>
                    <th className="imh-td-source">Source</th>
                    <th className="imh-td-paper">Paper</th>
                    <th className="imh-td-topics">Topics matched</th>
                    <th className="imh-td-qs">Questions imported</th>
                  </tr>
                </thead>
                <tbody>
                  {imports.slice(0, shown).map(imp => (
                    <tr key={imp.id} onClick={() => goToImport(imp.id)}>
                      <td className="imh-td-date">{formatDate(imp.imported_at)}</td>
                      <td className="imh-td-source">Law Drills</td>
                      <td className="imh-td-paper">
                        <span className="imh-paper-badge">{imp.paper}</span>
                      </td>
                      <td className="imh-td-topics">{imp.topics_matched}</td>
                      <td className="imh-td-qs">{imp.questions_imported}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {imports.length > shown && (
                <button className="imh-load-more" onClick={() => setShown(s => s + PAGE_SIZE)}>
                  Load more ({imports.length - shown} remaining)
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
